import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Erreur UI capturée par ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ag-container" style={{ textAlign: 'center', padding: '32px' }}>
          <h2>Oups, une erreur est survenue</h2>
          <p>Une erreur inattendue a été détectée. Veuillez recharger la page ou revenir plus tard.</p>
          <button
            type="button"
            className="ag-btn ag-btn--secondary"
            onClick={() => window.location.reload()}
          >
            Recharger
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
